import type { SVGProps } from 'react';
const SvgForaging = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 12.746A9.744 9.744 0 0 1 12.746 3h.508A9.744 9.744 0 0 1 23 12.746a2.667 2.667 0 0 1-2.668 2.668H5.668A2.667 2.667 0 0 1 3 12.746m5.254-6.229a7.68 7.68 0 0 0-3.185 6.229c0 .332.267.599.6.599h14.663c.332 0 .599-.267.599-.6 0-.517-.052-1.02-.146-1.508a2.07 2.07 0 1 1-1.634-3.41 7.67 7.67 0 0 0-4.112-2.551q.033.239.034.483a3.447 3.447 0 0 1-3.448 3.448 3.46 3.46 0 0 1-3.366-2.69zm3.81 10.276-.646 3.448h3.164l-.647-3.448h2.104l.728 3.884c.078.405-.03.819-.293 1.133s-.65.5-1.06.5h-4.828a1.37 1.37 0 0 1-1.06-.5 1.37 1.37 0 0 1-.293-1.133l.724-3.884h2.108M8.173 9.207a1.38 1.38 0 1 1 0 2.758 1.38 1.38 0 0 1 0-2.758"
    />
  </svg>
);
export default SvgForaging;
